
import { Stack, Box, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContextProvider";
import { useNavigate } from "react-router-dom";


const StepNavigationButtons = ({
    onBack,
    onProceed,
    loading = false,
    backLabel = "Back",
    proceedLabel = "Proceed",
    disableBack = false,
    hideBack = false,
}) => {
const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const handleLoginWithMobile = async () => {
    try {
      await logout();                 //  proper cleanup
      navigate("/loginpassword", { replace: true }); //  soft redirect
    } catch (err) {
      console.error("Logout error:", err);
    }
  };
    return (
        <>
        <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
            {/* Back */}
            {!hideBack && (
                <LoadingButton
                    fullWidth
                    variant="contained"
                    disabled={disableBack || loading}
                    onClick={onBack}
                    sx={{
                        height: 48,
                        borderRadius: "9px",
                        backgroundColor: "#F4F6FF",
                        color: "#5B5AFB",
                        fontSize: "16px",
                        fontWeight: 500,
                        fontFamily: "Figtree",
                        textTransform: "none",
                        boxShadow: "none",
                        "&:hover": {
                            backgroundColor: "#EEF1FF",
                            boxShadow: "none",
                        },
                    }}
                >
                    {backLabel}
                </LoadingButton>
            )}

            {/* Proceed */}
            <LoadingButton
                fullWidth
                variant="contained"
                loading={loading}
                onClick={onProceed}
                sx={{
                    height: 48,
                    borderRadius: "9px",
                    backgroundColor: "#5B5AFB",
                    color: "#FFFFFF",
                    fontSize: "16px",
                    fontWeight: 500,
                    fontFamily: "Figtree",
                    textTransform: "none",
                    boxShadow: "none",
                    "&:hover": {
                        backgroundColor: "#4F4EEA",
                        boxShadow: "none",
                    },
                    "& .MuiLoadingButton-loadingIndicator": {
                        color: "#FFFFFF",
                    },
                }}
            >
                {proceedLabel}
            </LoadingButton>
        </Stack>
        <Box sx={{ mt: 2 }}>
        <Typography
          component="button"
          onClick={handleLoginWithMobile}
          sx={{
            background: "none",
            border: "none",
            padding: 0,
            fontSize: 14,
            fontWeight: 500,
            color: "#5B5AFB",
            fontFamily: "Figtree",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          Login with mobile number
        </Typography>
      </Box>
      </>
    );
};

export default StepNavigationButtons;
